import {
  ArrowLeftRightIcon,
  BufferIcon,
  Button,
  ChannelIcon,
  Dialog,
  Flex,
} from '@buffer-mono/popcorn'
import { useModalManager } from '../../../ModalManager/hooks/useModalManager'

import styles from './InstagramSwitchToProfessionalAccountWarning.module.css'

import type { JSX } from 'react'

export function InstagramSwitchToProfessionalAccountWarningDialog(): JSX.Element {
  const { modalData, dismissModal } = useModalManager()

  const handleContinue = (): void => {
    dismissModal()

    if (modalData?.onContinue) {
      modalData.onContinue()
    }
  }

  const handleCancel = (): void => {
    dismissModal()

    if (modalData?.onCancel) {
      modalData.onCancel()
    }
  }

  return (
    <Dialog open onOpenChange={handleCancel}>
      <Dialog.Content className={styles.content}>
        <Dialog.Header>
          <Dialog.Title>
            <Flex justify="center">Confirm Instagram Account</Flex>
          </Dialog.Title>
        </Dialog.Header>

        <Dialog.Body className={styles.body}>
          <Flex direction="column" gap="md">
            <Flex gap="sm" align="center" justify="center" fullWidth>
              <BufferIcon />
              <ArrowLeftRightIcon color="subtle" />
              <ChannelIcon type="instagram" color="branded" />
            </Flex>
            <Dialog.Description>
              Please make sure you are currently signed into the correct
              Instagram account before converting. You can check which Instagram
              account you&apos;re currently signed into by visiting Instagram in
              another browser tab.
            </Dialog.Description>
          </Flex>
        </Dialog.Body>

        <Dialog.Footer>
          <Flex gap="sm" justify="end">
            <Button variant="tertiary" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleContinue}>
              Continue
            </Button>
          </Flex>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}

export default InstagramSwitchToProfessionalAccountWarningDialog
